import '../index.scss';
import React, { Component, useState } from 'react';
import { Connection, Port, RootState } from '..';
import { PortFormEditor } from './PortFormEditor';
import produce from "immer"
import { Accordion, Button, Card, Form, InputGroup } from 'react-bootstrap';
import { AiOutlineColumnWidth } from "react-icons/ai";
import { RiDeleteBin2Line, RiRouteLine } from 'react-icons/ri';
import { FormControlLabel, Switch, MuiThemeProvider, createMuiTheme } from '@material-ui/core';
import { green, purple } from '@material-ui/core/colors';
import { useSelector } from 'react-redux';


export { ConnectionFormEditor }

function ConnectionFormEditor(props: {
  connection: Connection
  onChange: (c: Connection) => void
  onDelete?: () => void
}) {

  const changePort = (index: number) => {
    return (port: Port) => {
      const connection = produce(props.connection, (draft: Connection) => {
        draft.ports[index] = port
      })
      props.onChange(connection)
    }
  }

  const settings = useSelector((state: RootState) => state.settings)

  return <li
      style={{listStyle: 'none'}}
    ><Card
      className='connectionCard'
    >
    <Accordion.Toggle
      as={Card.Header}
      eventKey={props.connection.id}
    >
      <RiRouteLine /> Connection
    </Accordion.Toggle>
    <Accordion.Collapse
      eventKey={props.connection.id}
    >
    <Card.Body>
    { props.onDelete !== undefined &&
      <Button
        onClick={props.onDelete}
        variant="outline-remove"
      >
        <RiDeleteBin2Line /> Remove
      </Button>
    }
      <Card.Title>Port A</Card.Title>
      <div className="cardSection">
        <PortFormEditor
          port={props.connection.ports[0]}
          onChange={changePort(0)}
        />
      </div>

      <Card.Title>Port B</Card.Title>
      <div className="cardSection">
        <PortFormEditor
          port={props.connection.ports[1]}
          onChange={changePort(1)}
        />
      </div>

    <InputGroup
      style={{margin: '1em'}}
    >
      <InputGroup.Prepend>
        <InputGroup.Text>
          <AiOutlineColumnWidth /> <span>&nbsp;</span> Width
        </InputGroup.Text>
      </InputGroup.Prepend>
      <Form.Control
        type="number"
        placeholder="Width"
        aria-label="Width"
        value={ Number.isNaN(props.connection.width) ? '' : props.connection.width }
        onChange={ (e) => props.onChange(produce(props.connection, (draft: Connection) => {
            draft.width = parseFloat(e.target.value)
          })) }
        style={{ maxWidth: '8em' }}
      />
      <InputGroup.Append>
        <InputGroup.Text>µm</InputGroup.Text>
      </InputGroup.Append>
    </InputGroup>

    <InputGroup
      style={{margin: '1em'}}
    >
      <InputGroup.Prepend>
        <InputGroup.Text>
          <AiOutlineColumnWidth /> <span>&nbsp;</span> Spacing
        </InputGroup.Text>
      </InputGroup.Prepend>
      <Form.Control
        type="number"
        placeholder="Spacing"
        aria-label="Spacing"
        value={ Number.isNaN(props.connection.spacing) ? '' : props.connection.spacing }
        onChange={ (e) => props.onChange(produce(props.connection, (draft: Connection) => {
            draft.spacing = parseFloat(e.target.value)
          })) }
        style={{ maxWidth: '8em' }}
      />
      <InputGroup.Append>
        <InputGroup.Text>µm</InputGroup.Text>
      </InputGroup.Append>
    </InputGroup>

    <InputGroup
      style={{margin: '1em'}}
    >
      <InputGroup.Prepend>
        <InputGroup.Text>
          <AiOutlineColumnWidth /> <span>&nbsp;</span> Bend Radius
        </InputGroup.Text>
      </InputGroup.Prepend>
      <Form.Control
        type="number"
        placeholder="Bend Radius"
        aria-label="Minimum Bend Radius"
        value={ Number.isNaN(props.connection.minBendRadius) ? '' : props.connection.minBendRadius }
        onChange={ (e) => props.onChange(produce(props.connection, (draft: Connection) => {
            draft.minBendRadius = parseFloat(e.target.value)
          })) }
        style={{ maxWidth: '8em' }}
      />
      <InputGroup.Append>
        <InputGroup.Text>µm</InputGroup.Text>
      </InputGroup.Append>
    </InputGroup>
    <MuiThemeProvider theme={createMuiTheme({
      palette: {
        primary: {
          main: '#222',
        },
        secondary: {
          main: settings.connectionDefaultColor,
        },
      },
    })}>
    <FormControlLabel
      control={
        <Switch
          checked={props.connection.modifyLength}
          onChange={(e) => {
            props.onChange(produce(props.connection, (draft: Connection) => {
              draft.modifyLength = e.target.checked
            }))
          }}
          color="primary"
        />
      }
      label="Modify Length"
    />
    </MuiThemeProvider>

    { props.connection.modifyLength &&
    <InputGroup
      style={{margin: '1em'}}
    >
      <InputGroup.Prepend>
        <InputGroup.Text>
          <AiOutlineColumnWidth /> <span>&nbsp;</span> Length
        </InputGroup.Text>
      </InputGroup.Prepend>
      <Form.Control
        type="number"
        placeholder="Desired Length"
        aria-label="Desired Length"
        value={ Number.isNaN(props.connection.length) ? '' : props.connection.length }
        onChange={ (e) => props.onChange(produce(props.connection, (draft: Connection) => {
            draft.length = parseFloat(e.target.value)
          })) }
        style={{ maxWidth: '8em' }}
      />
      <InputGroup.Append>
        <InputGroup.Text>µm</InputGroup.Text>
      </InputGroup.Append>
    </InputGroup>
    }
    </Card.Body>
    </Accordion.Collapse>
  </Card>
  </li>
}
